import React, { useCallback, useEffect } from 'react';

import ym from 'react-yandex-metrika';

import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router';
// @ts-ignore
import { SUBJECTS_SLUGS } from '@yandex-int/k-common/constants';
import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { CourseContainerWidgetV2__list } from 'common.components/widgets.course-container-v2/__list/course-container-widget-v2__list';

import { hrLight } from '@edu-frontend/modules/src/components/ui/Theme';
import { ThemeProvider } from '@edu-frontend/modules/src/shared/lib/ThemeProvider';
import { Spin, useStaticUrls } from 'platform-components';
import * as themesSelectors from 'store/themes/selectors';
import { Route, Switch } from 'platform-components/src/components/router/router';
import qs from 'query-string';
import { useChangeGrade } from 'common.components/grade-select/useChangeGrade';
import { DEFAULT_GRADE_INFORMATICS } from 'common.components/user/user.constants';
import { useGradeFromQueryOrTeam } from '../../..//utils/use-current-grade';
import Sidebar from '../../library.sidebar/sidebar';
import Pages from '../__pages/library__pages';
import { useCourseContainerGroups } from '../../library.index/queries';
import { Library__informatics__courseContainer } from './__course-container/library__informatics__course-container';
import { Library__informatics__sidebar } from './__sidebar/library__informatics__sidebar';

import './library__informatics.scss';

export const Library__informatics = () => {
    const staticUrls = useStaticUrls();
    const { search } = useLocation();
    const query = qs.parse(search);
    const grade = useGradeFromQueryOrTeam(DEFAULT_GRADE_INFORMATICS);
    const handleSelectGrade = useChangeGrade();

    const { containerSlug = '' } = useParams<{ containerSlug?: string }>();
    const { isSuccess, data: courseContainerGroups = {} } = useCourseContainerGroups();

    // если в квери отсутствует грейд, добавляем грейд курс-контейнера или текущего класса
    useEffect(() => {
        const gradeFromContainerSlug = courseContainerGroups?.[containerSlug]?.[0]?.grade;
        if (!query.grade && isSuccess) {
            const currentGrade = gradeFromContainerSlug ?? grade;
            handleSelectGrade(currentGrade, { isReplace: true });
        }
    }, [grade, handleSelectGrade, query.grade, courseContainerGroups, containerSlug, isSuccess]);

    if (!isSuccess) {
        return null;
    }

    return (
        <Switch>
            <Route component={CourseContainersContent} exact path={staticUrls.deepLabLibrary} />
            <Route component={CourseContainersContent} exact path={staticUrls.labLibrarySubject} />
            <Route component={CourseContainersContent} path={staticUrls.labClassLibrarySubjectTab} />
            <Route component={CourseContainersContent} path={staticUrls.labLibrarySubjectTab} />
            <Route component={CourseContainerContent} path={staticUrls.labLibrarySubjectCollection} />
            <Route component={CourseContainerContent} path={staticUrls.labLibrarySubjectCommonCourseContainer} />
            <Route component={AdditionalInfoContent} />
        </Switch>
    );
};

const AdditionalInfoContent = () => {
    const { subject } = useParams<{ subject: SUBJECTS_SLUGS }>();
    const themesLoadingStatus = useSelector((store) => themesSelectors.getRootThemesLoadingStatus(store, subject));
    const isLoadingThemes = themesLoadingStatus === LOADING_STATUSES.LOADING;

    return (
        <div className="library__content">
            {isLoadingThemes ? (
                <Spin center />
            ) : (
                <>
                    <Sidebar showBackToCalendarPlan />
                    <div className="library__pages">
                        <Pages />
                    </div>
                </>
            )}
        </div>
    );
};

const CourseContainersContent = () => {
    const grade = useGradeFromQueryOrTeam(DEFAULT_GRADE_INFORMATICS);

    const handleCourseBannerClick = useCallback(() => {
        ym('reachGoal', 'teacher_select_coursecontainer,', { from: 'coursecontainer_list', grade });
    }, [grade]);

    return (
        <ThemeProvider isRoot={false} theme={hrLight}>
            <div className="library__content library__informatics">
                <Library__informatics__sidebar />
                <div className="library__pages">
                    <CourseContainerWidgetV2__list onItemClick={handleCourseBannerClick} subject="informatics" />
                </div>
            </div>
        </ThemeProvider>
    );
};

const CourseContainerContent = () => {
    return (
        <ThemeProvider isRoot={false} theme={hrLight}>
            <div className="library__content library__informatics">
                <Library__informatics__sidebar />
                <div className="library__pages">
                    <Library__informatics__courseContainer />
                </div>
            </div>
        </ThemeProvider>
    );
};
